/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   aex\service\user\server\clientgeneratorconfigs\genclient.json
 */

"use strict";

import Contracts = require("Aex/UserAad/Contracts");
import VSS_Service = require("VSS/Service");
import VSS_WebApi = require("VSS/WebApi/RestClient");

export class CommonMethods4_1To7_2 extends VSS_WebApi.VssHttpClient {

    public static serviceInstanceId = "00000041-0000-8888-8000-000000000000";
    protected aadMembershipApiVersion: string;

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
    }

    /**
     * @param {number} max
     * @return IPromise<Contracts.UserAadMembershipData>
     */
    public getUserAadMembership(
        max?: number
        ): IPromise<Contracts.UserAadMembershipData> {

        const queryValues: any = {
            max: max
        };

        return this._beginRequest<Contracts.UserAadMembershipData>({
            httpMethod: "GET",
            area: "UserAad",
            locationId: "a6dd3765-cde6-4278-a12f-527b2d22fc1d",
            resource: "AadMembership",
            routeTemplate: "_apis/{area}/{resource}",
            queryParams: queryValues,
            apiVersion: this.aadMembershipApiVersion
        });
    }
}

/**
 * @exemptedapi
 */
export class UserAadHttpClient7_2 extends CommonMethods4_1To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.aadMembershipApiVersion = "7.2-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class UserAadHttpClient7_1 extends CommonMethods4_1To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.aadMembershipApiVersion = "7.1";
    }
}

/**
 * @exemptedapi
 */
export class UserAadHttpClient7 extends CommonMethods4_1To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.aadMembershipApiVersion = "7.0";
    }
}

/**
 * @exemptedapi
 */
export class UserAadHttpClient6_1 extends CommonMethods4_1To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.aadMembershipApiVersion = "6.1";
    }
}

/**
 * @exemptedapi
 */
export class UserAadHttpClient6 extends CommonMethods4_1To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.aadMembershipApiVersion = "6.0";
    }
}

/**
 * @exemptedapi
 */
export class UserAadHttpClient5_2 extends CommonMethods4_1To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.aadMembershipApiVersion = "5.2";
    }
}

/**
 * @exemptedapi
 */
export class UserAadHttpClient5_1 extends CommonMethods4_1To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.aadMembershipApiVersion = "5.1";
    }
}

/**
 * @exemptedapi
 */
export class UserAadHttpClient5 extends CommonMethods4_1To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.aadMembershipApiVersion = "5.0";
    }
}

/**
 * @exemptedapi
 */
export class UserAadHttpClient4_1 extends CommonMethods4_1To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.aadMembershipApiVersion = "4.1";
    }
}

export class UserAadHttpClient extends UserAadHttpClient7_2 {
    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
    }
}

const clientMapping: { [id: string]: new (routeRequestPath: string) => VSS_WebApi.VssHttpClient; } = {
    "7.2": UserAadHttpClient7_2,
    "7.1": UserAadHttpClient7_1,
    "7.0": UserAadHttpClient7,
    "6.1": UserAadHttpClient6_1,
    "6.0": UserAadHttpClient6,
    "5.2": UserAadHttpClient5_2,
    "5.1": UserAadHttpClient5_1,
    "5.0": UserAadHttpClient5,
    "4.1": UserAadHttpClient4_1
}

/**
 * Gets an http client targeting the latest released version of the APIs.
 *
 * @return UserAadHttpClient7_1
 */
export function getClient(options?: VSS_WebApi.IVssHttpClientOptions): UserAadHttpClient7_1 {
    if ((<any>window).VSS && (<any>window).VSS.VssSDKRestVersion && clientMapping[(<any>window).VSS.VssSDKRestVersion]) {
        return VSS_Service.getClient<UserAadHttpClient7_1>(<any>(clientMapping[(<any>window).VSS.VssSDKRestVersion]), undefined, undefined, undefined, options);
    }
    else {
        return VSS_Service.getClient<UserAadHttpClient7_1>(UserAadHttpClient7_1, undefined, undefined, undefined, options);
    }
}
